import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Promo from "../../assets/img/promo-announcement.json";
import { fetchAllSOC } from "../../utils/routes";
// import IconBeta from "../../assets/img/icon-beta.svg";
// import PlayStoreButton from "../../assets/img/btn-playstore.png";
// import PromoImg from "../../assets/img/promo-img.png";
import Lottie from "react-lottie-player";
import LogoOneZapp from "../../assets/img/brand-logo.svg";
import closei from "../../assets/img/Overlay close icon.svg";
import { FiEye } from "react-icons/fi";

export const SOCAnnouncementDialog = () => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [socData, setSocData] = useState([]);

  const SOC_LC = getLocalStorageItemWithExpiry("oz-soc-update");

  async function getAllSOC() {
    try {
      const response = await fetch(fetchAllSOC);
      const res = await response.json();
      // Use the data as needed
      let data = res?.result?.list;
      setSocData(data[data.length - 1]);
      // setSocData(data.result);
      setLoading(false);
    } catch (error) {
      // console.error(error);
      setLoading(false);
    }
  }

  function setLocalStorageItemWithExpiry(key, value, expiryTimeInMs) {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + expiryTimeInMs,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getLocalStorageItemWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  const handleClose = () => {
    setShow(false);
    // adding new local storage
    if (!SOC_LC) {
      // Your logic
      setLocalStorageItemWithExpiry(
        "oz-soc-update",
        "OneZapp Schedule of charges update",
        60000 * 60 * 24 * 14
      ); // 60000 ms = 1 min
    }
  };

  useEffect(() => {
    getAllSOC();
    const specificDates = [
      {
        month: 1, // For January
        startDay: 1, // Start day of the two-week period
        endDay: 14, // End day of the two-week period
      },
      {
        month: 7, // For July
        startDay: 1, // Start day of the two-week period
        endDay: 14, // End day of the two-week period
      },
    ];

    const today = new Date();
    const currentMonth = today.getMonth() + 1; // getMonth() returns 0-11
    const currentDay = today.getDate();

    const isSpecialDay = specificDates.some(
      (date) =>
        currentMonth === date.month &&
        currentDay >= date.startDay &&
        currentDay <= date.endDay
    );
    if (isSpecialDay && !SOC_LC) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  return (
    <>
      <Modal
        className="announcement-dialog promo-dialog"
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <span className="logo-wrap">
              <img src={LogoOneZapp} alt="logo onezapp" height={40} />
            </span>
          </Modal.Title>
          <button
            type="button"
            className="close-btn"
            style={{
              background: "transparent",
              border: "transparent",
            }}
            onClick={(e) => handleClose(e)}
          >
            <img className="img-close color-white" src={closei} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Lottie
            loop
            animationData={Promo}
            play
            style={{ width: 200, height: 200 }}
          />
          <h1 className="text-center">“Important Announcement”</h1>
          <div className="align-items-center justify-content-center">
            <h5>
              Schedule of Charges has been updated
              <span className="d-block text-pri mt-3" style={{ fontSize: 14 }}>
                {socData.fileName}{" "}
              </span>
            </h5>
            <a
              className="btn btn-secondary mt-2"
              href={`${process.env.REACT_APP_BASE_URL}${socData.filePath}`}
              download={`${socData.fileName}.pdf`}
              target="_blank"
              rel="noreferrer"
            >
              <FiEye /> View
            </a>
            {/* <Link to="/charges" className="text-white">
              <small style={{ fontSize: 14 }}>Read More...</small>
            </Link> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
